import { $$ } from "../util/dom";

$$(".food-type").forEach(el => el.style.maxHeight = `${el.getBoundingClientRect().height}px`);
